var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSymbolReactShort(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 120,
    viewBox: "0 0 121 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.865234 30C0.865234 13.4315 14.2967 0 30.8652 0H90.8652C107.434 0 120.865 13.4315 120.865 30V90C120.865 106.569 107.434 120 90.8652 120H30.8652C14.2967 120 0.865234 106.569 0.865234 90V30Z",
    fill: "url(#paint0_linear_219_4780)",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0474 59.9444C67.0474 56.6342 64.2798 53.9505 60.8654 53.9505C57.4513 53.9505 54.6833 56.6342 54.6833 59.9444C54.6833 63.2549 57.4513 65.9386 60.8654 65.9386C64.2798 65.9386 67.0474 63.2549 67.0474 59.9444Z",
    fill: "url(#paint1_linear_219_4780)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.9432 48.8162C82.2487 43.6726 83.8898 34.1342 78.1047 30.9004C72.3469 27.6806 64.8541 33.8502 60.8976 37.5535C56.9525 33.8871 49.2493 27.7439 43.4691 30.988C37.7135 34.2185 39.4884 43.5988 40.8228 48.7746C35.4538 50.2533 26.25 53.4379 26.25 59.9444C26.25 66.4325 35.4442 69.8972 40.7815 71.3744C39.4421 76.5789 37.7561 85.8252 43.5191 89.0484C49.3206 92.2919 57.0001 86.295 60.9931 82.5513C64.9751 86.2763 72.396 92.3125 78.155 89.0802C83.9323 85.8376 82.4275 76.4271 81.093 71.2211C86.2668 69.7408 95.4808 66.3515 95.4808 59.9444C95.4808 53.5003 86.2277 50.2899 80.9432 48.8162ZM80.2875 68.4622C79.4112 65.7729 78.2285 62.913 76.7818 59.9587C78.1627 57.0741 79.2994 54.2511 80.1511 51.579C84.0251 52.6679 92.5235 55.1568 92.5235 59.9444C92.5235 64.7768 84.3684 67.2893 80.2875 68.4622ZM76.673 86.5985C72.3763 89.01 65.9934 83.2376 63.0527 80.4944C65.0035 78.4256 66.9531 76.0205 68.8557 73.3499C72.2028 73.062 75.3647 72.5912 78.2322 71.9486C79.1715 75.6309 80.989 84.176 76.673 86.5985ZM44.9968 86.564C40.6994 84.1616 42.6636 75.9107 43.649 72.0769C46.4846 72.685 49.6236 73.1226 52.9786 73.3864C54.8938 75.9997 56.8998 78.4018 58.9213 80.5053C56.4237 82.8479 49.3143 88.9777 44.9968 86.564ZM29.2073 59.9444C29.2073 55.0938 37.6548 52.6231 41.617 51.5368C42.4835 54.2689 43.6199 57.1255 44.9913 60.0142C43.6021 62.946 42.4495 65.848 41.575 68.6122C37.797 67.5638 29.2073 64.798 29.2073 59.9444ZM44.9508 33.4697C49.2658 31.0481 55.9609 36.9458 58.8251 39.6003C56.814 41.6943 54.8264 44.0783 52.9277 46.6765C49.6717 46.9691 46.5548 47.439 43.6894 48.0685C42.6144 43.894 40.6406 35.8887 44.9508 33.4697ZM70.9714 49.7933C73.1804 50.0636 75.2967 50.4231 77.2839 50.863C76.6874 52.717 75.9438 54.6557 75.0681 56.6431C73.7986 54.3075 72.4359 52.0191 70.9714 49.7933ZM60.8985 41.6495C62.2625 43.0822 63.6287 44.6822 64.9725 46.418C62.2466 46.2931 59.5161 46.2925 56.7901 46.4162C58.1351 44.6965 59.513 43.0989 60.8985 41.6495ZM46.6881 56.641C45.8268 54.6604 45.0899 52.7132 44.4882 50.8327C46.4635 50.4041 48.5699 50.0538 50.7646 49.7879C49.296 52.0088 47.9356 54.2965 46.6881 56.641ZM50.8277 70.3055C48.5604 70.0601 46.4221 69.7277 44.4475 69.3109C45.0587 67.3972 45.8118 65.4081 46.6915 63.385C47.9562 65.7537 49.3373 68.0636 50.8277 70.3055ZM60.9803 78.4419C59.5785 76.9753 58.1805 75.3533 56.8149 73.6086C59.5565 73.7131 62.3034 73.7133 65.0445 73.5947C63.6964 75.3711 62.3351 76.9955 60.9803 78.4419ZM75.0963 63.2819C76.0216 65.327 76.8017 67.3054 77.4212 69.1868C75.4137 69.6309 73.2466 69.9886 70.9631 70.2541C72.4385 67.9863 73.8227 65.6622 75.0963 63.2819ZM67.2052 70.6017C63.0119 70.8922 58.7921 70.8891 54.5972 70.6255C52.2136 67.2495 50.0918 63.6991 48.2602 60.0133C50.0828 56.3351 52.1893 52.7918 54.5617 49.4211C58.7597 49.1134 62.9834 49.1126 67.1813 49.4228C69.5332 52.7933 71.6366 56.3275 73.5015 59.9726C71.6587 63.649 69.5412 67.1995 67.2052 70.6017ZM76.6276 33.3844C80.9437 35.7982 79.0225 44.3706 78.0796 48.0982C75.2075 47.4557 72.0885 46.9774 68.823 46.6803C66.9206 44.0539 64.9496 41.6658 62.9709 39.5988C65.872 36.8871 72.3533 30.9944 76.6276 33.3844Z",
    fill: "url(#paint2_linear_219_4780)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_219_4780",
    x1: 60.8652,
    y1: 0,
    x2: 60.8652,
    y2: 120,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9EBFF",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_219_4780",
    x1: 60.8654,
    y1: 30,
    x2: 60.8654,
    y2: 90,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9EBFF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9EBFF",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_219_4780",
    x1: 60.8654,
    y1: 30,
    x2: 60.8654,
    y2: 90,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9EBFF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9EBFF",
    stopOpacity: 0.6
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolReactShort);
export default __webpack_public_path__ + "static/media/symbol-react-short.0e3f1e173254e598e9265a5c1cafdebc.svg";
export { ForwardRef as ReactComponent };